import { isAxiosError } from "axios";

export const pickLocalized = <T>(
  english: T,
  arabic: T | undefined,
  isArabic: boolean | undefined
): T => (isArabic ? arabic : undefined) ?? english;

export const getSubmitErrorMessage = (error: unknown, fallback: string): string => {
  const detail = isAxiosError<{ detail?: unknown }>(error)
    ? error.response?.data?.detail
    : undefined;
  return typeof detail === "string" ? detail : fallback;
};
